module.exports = __webpack_public_path__ + "static/media/view.11dc67b9.svg";